export const PACKAGE = {
    ALL: 'ALL',
    DISPLAY: 'DISPLAY',
    SOCIAL_VIDEO: 'SOCIAL_VIDEO',
} as const;

export type PACKAGE = (typeof PACKAGE)[keyof typeof PACKAGE];
